import React from "react";
import styles from "./Editorial.module.less";

export default function Editorial(props: { className?: string, children: React.ReactNode }) {
    return <div className={[styles.Editorial, props.className].join(" ")}>{props.children}</div>;
}
